import { render } from "./MBPRadio.vue?vue&type=template&id=f3848ab2&scoped=true"
import script from "./MBPRadio.vue?vue&type=script&lang=js"
export * from "./MBPRadio.vue?vue&type=script&lang=js"

import "./MBPRadio.vue?vue&type=style&index=0&id=f3848ab2&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3848ab2"]])

export default __exports__